/* ============================================
   COVRFLY v10.1 — PRODUCTION CLEAN
   Base + sticky hide + scroll restore (no elastic)
   Audited by GPT + Gemini — all fixes applied
   ============================================ */
(() => {
  'use strict';
  if (window.__cfPsV10) return;
  window.__cfPsV10 = true;
  const STYLE_ID     = 'cf-ps';
  const VIEWALL_ID   = 'cf-viewall';
  const VIEWALL_LINK = 'cf-viewall-link';
  const NORESULTS_ID = 'cf-noresults';
  const HEADING_TEXT  = 'RESULTADOS';
  const PLACEHOLDER   = 'Buscar...';
  const MIN_CHARS     = 2;
  const NORESULTS_MSG = 'Hmm, no encontramos ningún resultado que coincida con tu búsqueda';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const setImp = (el, styles) => {
    if (!el) return;
    for (const [k, v] of Object.entries(styles)) el.style.setProperty(k, v, 'important');
  };
  const ensureStyle = () => {
    if (document.getElementById(STYLE_ID)) return;
    const st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent = `
/* === COVRFLY Fase 9 — Kill iOS tap highlight GLOBALMENTE ===
   iOS Safari pinta un rectángulo rgba(0,0,0,.15) sobre cualquier elemento
   tappable (botón, link, input, role=button, tabindex) al hacer tap, con
   fade-out ~300-500ms. Es feo y se ve barato. Lo matamos en TODO.
   Nota: -webkit-tap-highlight-color solo aplica a elementos realmente
   tappables, así que aplicar a * es seguro (no afecta elementos inertes). */
*, *::before, *::after{
  -webkit-tap-highlight-color:transparent!important;
}
#predictive__search_overlay{
  position:fixed!important;inset:0!important;width:100vw!important;
  height:100vh!important;
  height:100dvh!important;
  height:var(--cf-lupita-h, 100dvh)!important;
  display:flex!important;justify-content:flex-start!important;align-items:stretch!important;
  padding:0!important;background:rgba(8,10,12,.58)!important;
  backdrop-filter:blur(14px) saturate(150%)!important;-webkit-backdrop-filter:blur(14px) saturate(150%)!important;
  z-index:99999!important;overscroll-behavior:contain!important;
}
#predictive__search_overlay .search__content_inner{
  width:min(440px, 92vw)!important;max-width:none!important;min-width:0!important;
  height:100vh!important;
  height:100dvh!important;
  height:var(--cf-lupita-h, 100dvh)!important;
  margin:0!important;padding:0!important;
  background:rgba(224,224,224,0.70)!important;
  backdrop-filter:blur(25px) saturate(180%)!important;
  -webkit-backdrop-filter:blur(25px) saturate(180%)!important;
  border-radius:0!important;
  box-shadow:0 20px 60px rgba(0,0,0,.22)!important;
  border:none!important;border-right:1px solid rgba(0,0,0,.06)!important;
  overflow:hidden!important;
  font-family:var(--font-body-family),sans-serif!important;
  display:flex!important;flex-direction:column!important;
  justify-content:flex-start!important;align-items:stretch!important;
  /* Swipe-to-close: permite scroll vertical dentro, bloquea gestos horizontales
     del browser (pull-to-refresh, atrás-historia) para que JS los capture. */
  touch-action:pan-y!important;
  overscroll-behavior:contain!important;
}
/* Hijos del panel: transparentes para que se vea el glass del panel */
#predictive__search_overlay predictive-search.search-modal__form,
#predictive__search_overlay form.search.search-modal__form,
#predictive__search_overlay .predictive-search.predictive-search--header,
#predictive__search_overlay .cf-search-populars{background:transparent!important;}
predictive-search.search-modal__form{
  width:100%!important;flex:1 1 0px!important;min-height:0!important;
  display:flex!important;flex-direction:column!important;
}
form.search.search-modal__form{
  width:100%!important;flex:1 1 0px!important;min-height:0!important;
  display:flex!important;flex-direction:column!important;
  margin:0!important;padding:0!important;
}
/* COVRFLY — Fase 8: Homologación con menú hamburguesa (Apple-style)
   Micro-offset fix: Illustrator overlay reveló que el contenido del input row
   estaba 3pt (~1px CSS @3x) más bajo que el .cfm17-srch del menú. El <input
   placeholder> se renderiza ~1px más abajo que un <span> con el mismo
   font-size/line-height. Compensamos con padding asimétrico 13px top / 15px
   bottom (total 28px igual que 14+14 del menú, pero contenido shifteado 1px
   hacia arriba). */
.search__input_field.input__field_form{
  position:relative!important;z-index:50!important;flex:0 0 auto!important;
  background:transparent!important;padding:13px 20px 15px!important;
  border-bottom:none!important;
  display:flex!important;align-items:center!important;gap:14px!important;
  margin:0!important;height:auto!important;min-height:0!important;flex-wrap:nowrap!important;
}
/* Wrapper del contenido del input row — misma altura que span del menú */
.search__input_field.input__field_form > *{
  min-height:0!important;
}
button.search__button.input__field_form_button{
  flex:0 0 20px!important;
  width:20px!important;height:20px!important;
  min-width:20px!important;min-height:20px!important;
  max-width:20px!important;max-height:20px!important;
  box-sizing:border-box!important;
  border-radius:0!important;border:none!important;
  background:transparent!important;color:#555!important;
  display:flex!important;align-items:center!important;justify-content:center!important;
  padding:0!important;margin:0!important;order:-1!important;
  font-size:0!important;line-height:1!important;
  position:static!important;
  /* Micro-offset: el row subió 1px (padding 13/15) y la lupa sólo estaba
     1.5pt (~0.5px) desalineada → ahora compensa con translateY(0.5px)
     para que vuelva a su posición original respecto al menú. */
  transform:translateY(0.5px)!important;
  -webkit-appearance:none!important;appearance:none!important;
  outline:none!important;-webkit-tap-highlight-color:transparent!important;
  box-shadow:none!important;
  vertical-align:middle!important;
}
button.search__button.input__field_form_button .icon,
button.search__button.input__field_form_button svg{
  width:20px!important;height:20px!important;
  display:block!important;
  stroke:currentColor!important;fill:none!important;
}
input.search__input.input__field{
  flex:1 1 auto!important;min-width:0!important;
  height:auto!important;min-height:0!important;
  border:none!important;border-radius:0!important;
  box-sizing:content-box!important;
  padding:0 32px 0 0!important;margin:0!important;
  font-size:17px!important;font-weight:400!important;
  line-height:1.4!important;letter-spacing:-0.01em!important;
  font-family:inherit!important;
  color:#111!important;background:transparent!important;
  outline:none!important;
  -webkit-appearance:none!important;appearance:none!important;
  -webkit-tap-highlight-color:transparent!important;
  text-indent:0!important;vertical-align:middle!important;
  caret-color:#111!important;
  transition:none!important;
}
/* COVRFLY Fase 9 — Fix cuadro semi-transparente al tocar input (iOS tap highlight)
   iOS renderiza un rectángulo rgba(0,0,0,.15) sobre el input al hacer tap que
   fade-out en ~300-500ms. Lo matamos en el input, su wrapper, y el overlay. */
.search__input_field.input__field_form,
#predictive__search_overlay,
#predictive__search_overlay *{
  -webkit-tap-highlight-color:transparent!important;
}
/* Safari quirk: type="search" agrega botón clear nativo — esconderlo */
input.search__input.input__field::-webkit-search-cancel-button,
input.search__input.input__field::-webkit-search-decoration{
  -webkit-appearance:none!important;display:none!important;
}
/* Placeholder: heredar font/letter-spacing/line-height del input (algunos engines no heredan automáticamente) */
input.search__input.input__field::placeholder{
  color:#888!important;font-weight:400!important;
  font-size:17px!important;line-height:1.4!important;
  letter-spacing:-0.01em!important;font-family:inherit!important;
  opacity:1!important;
}
input.search__input.input__field::-webkit-input-placeholder{
  color:#888!important;font-weight:400!important;
  font-size:17px!important;line-height:1.4!important;
  letter-spacing:-0.01em!important;font-family:inherit!important;
  opacity:1!important;
}

/* === COVRFLY — Cursor custom premium ===
   El cursor nativo del browser no se puede estilizar (solo caret-color).
   Usamos un pseudo-elemento fijo en la posición del primer caracter del input,
   con parpadeo suave (fade in/out). Solo visible cuando el input está VACÍO
   (placeholder shown). Cuando el usuario escribe, el cursor nativo toma
   el relevo y sigue la posición del cursor real. */
input.search__input.input__field{
  caret-color:transparent!important;
}
input.search__input.input__field:not(:placeholder-shown){
  caret-color:#111!important;
}
.search__input_field.input__field_form::after{
  content:''!important;
  position:absolute!important;
  left:54px!important;  /* padding-left (20) + button (20) + gap (14) */
  top:50%!important;
  transform:translateY(-50%)!important;
  width:1.5px!important;
  height:20px!important;
  background:#111!important;
  border-radius:1px!important;
  pointer-events:none!important;
  animation:cfCursorBlink 1.2s ease-in-out infinite!important;
  z-index:5!important;
}
/* Ocultar cursor custom cuando el input tiene texto */
.search__input_field.input__field_form:has(input.search__input.input__field:not(:placeholder-shown))::after{
  display:none!important;
}
@keyframes cfCursorBlink{
  0%,100%{opacity:1;}
  50%{opacity:0;}
}
input.search__input.input__field:focus{
  border:none!important;
  box-shadow:none!important;background:transparent!important;
}
.cf-search-clear{
  position:absolute!important;top:50%!important;right:20px!important;
  transform:translateY(-50%)!important;
}
#search__close_btn,.modal__close-button{
  order:0!important;align-self:flex-end!important;
  flex:0 0 44px!important;
  width:44px!important;height:44px!important;border-radius:50%!important;
  border:1px solid rgba(0,0,0,.08)!important;
  background:rgba(255,255,255,.35)!important;color:#111!important;
  display:flex!important;align-items:center!important;justify-content:center!important;
  padding:0!important;
  margin:calc(max(env(safe-area-inset-top, 14px), 14px) + 2px) 16px 10px 0!important;
  position:static!important;transform:none!important;
  outline:none!important;-webkit-tap-highlight-color:transparent!important;
  box-shadow:none!important;z-index:100!important;font-size:16px!important;
  transition:transform .15s ease, background .15s ease!important;
}
#search__close_btn svg,.modal__close-button svg{
  width:18px!important;height:18px!important;
  stroke:currentColor!important;fill:none!important;
}
#search__close_btn:focus,#search__close_btn:focus-visible,
.modal__close-button:focus,.modal__close-button:focus-visible{
  outline:none!important;box-shadow:none!important;
}
#search__close_btn:active,.modal__close-button:active{
  transform:scale(.92)!important;background:rgba(255,255,255,.55)!important;
}
.predictive-search.predictive-search--header{
  flex:1 1 0px!important;min-height:0!important;
  overflow-y:auto!important;overflow-x:hidden!important;
  -webkit-overflow-scrolling:touch!important;
  padding:10px 12px 0 12px!important;position:relative!important;
  display:flex!important;flex-direction:column!important;
  overscroll-behavior:contain!important;border:none!important;box-shadow:none!important;
}
.predictive-search.predictive-search--header::-webkit-scrollbar{display:none;}
.predictive-search.predictive-search--header.cf-loading{
  opacity:.45!important;pointer-events:none!important;transition:opacity 150ms ease!important;
}
#predictive-search-results{padding:0!important;flex:1 0 auto!important;border:none!important;}
.predictive-search__heading{
  margin:4px 4px 10px!important;font-size:12px!important;font-weight:600!important;
  letter-spacing:.12em!important;text-transform:uppercase!important;
  color:rgba(0,0,0,.42)!important;border-bottom:none!important;padding:0!important;
}
ul.predictive-search__results-list{
  display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;
  gap:10px!important;list-style:none!important;margin:0!important;padding:0 0 12px 0!important;
}
li.predictive-search__list-item{margin:0!important;padding:0!important;height:auto!important;border:none!important;}
a.predictive-search__item.predictive-search__item--link{
  display:flex!important;flex-direction:column!important;
  width:100%!important;height:100%!important;text-decoration:none!important;
  background:#fff!important;border:1px solid rgba(0,0,0,.06)!important;
  border-radius:16px!important;padding:4px!important;
  box-shadow:0 2px 6px rgba(0,0,0,.04),0 10px 28px rgba(0,0,0,.08)!important;
  transition:transform 180ms cubic-bezier(.2,.9,.2,1)!important;overflow:hidden!important;
  -webkit-tap-highlight-color:transparent!important;
}
a.predictive-search__item.predictive-search__item--link:active{transform:scale(.985)!important;}
img.predictive-search__image{
  width:100%!important;height:auto!important;aspect-ratio:1/1!important;
  border-radius:14px!important;object-fit:contain!important;
  object-position:center!important;background:rgba(0,0,0,.02)!important;
  display:block!important;flex-shrink:0!important;
}
.predictive-search__item-content{
  display:flex!important;flex-direction:column!important;align-items:center!important;
  text-align:center!important;gap:1px!important;padding:3px 4px 2px!important;
  min-width:0!important;overflow:hidden!important;max-width:100%!important;
}
.predictive-search__item-heading,.predictive-search__item-heading.h6{
  margin:0!important;font-size:11.5px!important;font-weight:450!important;
  line-height:1.3!important;color:rgba(10,12,14,.78)!important;
  white-space:nowrap!important;overflow:hidden!important;
  text-overflow:ellipsis!important;max-width:100%!important;width:100%!important;
  display:block!important;
}
.predictive-search__item-content .price{
  margin:0!important;font-size:10.5px!important;font-weight:400!important;color:rgba(0,0,0,.45)!important;
}
.predictive-search__item--term{display:none!important;}
#cf-viewall{
  padding:10px 12px!important;margin:0!important;
  background:rgba(255,255,255,.97)!important;
  border-top:1px solid rgba(0,0,0,.07)!important;
  flex-shrink:0!important;
  backdrop-filter:blur(8px)!important;-webkit-backdrop-filter:blur(8px)!important;
}
#cf-viewall-link{
  display:flex!important;align-items:center!important;justify-content:center!important;
  width:100%!important;height:44px!important;border-radius:999px!important;
  border:1.5px solid rgba(0,0,0,.10)!important;background:#fff!important;
  color:rgba(10,12,14,.85)!important;font-size:12.5px!important;font-weight:500!important;
  text-decoration:none!important;transition:transform 180ms cubic-bezier(.2,.9,.2,1)!important;
}
#cf-viewall-link:active{transform:scale(.985)!important;}
#cf-noresults{
  flex-direction:column!important;align-items:center!important;
  justify-content:flex-start!important;text-align:center!important;
  padding:40px 24px 60px!important;gap:12px!important;flex:1!important;
}
#cf-noresults span{
  font-size:15px!important;font-weight:450!important;color:rgba(0,0,0,.75)!important;
  line-height:1.6!important;max-width:260px!important;text-align:center!important;letter-spacing:.01em!important;
}
.search__content_inner{border:none!important;}

/* COVRFLY — Fix línea azul: outline:none en todos los contenedores focusables del modal */
#predictive__search_overlay,
#predictive__search_overlay:focus,#predictive__search_overlay:focus-visible,
.search__content_inner,
.search__content_inner:focus,.search__content_inner:focus-visible,
search-modal,search-modal:focus,search-modal:focus-visible,
predictive-search,predictive-search:focus,predictive-search:focus-visible,
form.search.search-modal__form:focus,form.search.search-modal__form:focus-visible,
.predictive-search.predictive-search--header:focus,
.predictive-search.predictive-search--header:focus-visible{
  outline:none!important;box-shadow:none!important;
}
.predictive-search{border:none!important;}

/* === COVRFLY Fase 8.1 — Animación slide desde la izquierda ===
   Nota: visibility:visible + pointer-events:none (en vez de visibility:hidden)
   para que iOS pueda enfocar el input programáticamente antes de que la
   animación termine (visibility:hidden hace descendientes no-focusables). */
#predictive__search_overlay{
  transform:none!important;
  opacity:0!important;
  visibility:visible!important;
  pointer-events:none!important;
  transition:opacity 0.28s ease!important;
}
search-modal.active #predictive__search_overlay{
  opacity:1!important;
  pointer-events:auto!important;
}
#predictive__search_overlay .search__content_inner{
  transform:translateX(-100%)!important;
  transition:transform 0.34s cubic-bezier(0.22, 1, 0.36, 1)!important;
  will-change:transform!important;
}
search-modal.active #predictive__search_overlay .search__content_inner{
  transform:translateX(0)!important;
}

/* === COVRFLY Fase 8.2 — Modo from-menu: fade-only (sensación de transformación) === */
search-modal.from-menu #predictive__search_overlay .search__content_inner{
  transform:none!important;
  opacity:0!important;
  transition:opacity 0.25s ease!important;
}
search-modal.from-menu.active #predictive__search_overlay .search__content_inner{
  opacity:1!important;
}

/* === COVRFLY Fase 9 — Scroll Lock v3: touch-action defense === */
html.cf-lupita-locked,
html.cf-lupita-locked body {
  touch-action: none !important;
  -webkit-touch-callout: none !important;
}
html.cf-lupita-locked #predictive__search_overlay .predictive-search.predictive-search--header,
html.cf-lupita-locked #predictive__search_overlay .cf-search-populars,
html.cf-lupita-locked #predictive__search_overlay .search__content_inner {
  touch-action: pan-y !important;
}

/* === COVRFLY — Búsquedas recientes: tap target 44px + centrado + :active feedback ===
   iOS HIG: botones táctiles mínimo 44×44. El SVG se queda 24×24 (mismo tamaño visual),
   pero el botón crece a 44×44 con padding. Row + link con min-height 44px para
   garantizar centrado vertical perfecto entre texto y SVG (compensando asimetría
   ascent/descent del font). :active sin transition = feedback instantáneo visible
   incluso en taps rápidos (el click handler borra el elemento inmediatamente). */
#predictive__search_overlay .cf-search-recents__item{
  display:flex!important;align-items:center!important;
  justify-content:space-between!important;
  gap:12px!important;padding:0!important;margin:0!important;
  min-height:44px!important;border:0!important;
}
#predictive__search_overlay .cf-search-recents__link{
  flex:1 1 auto!important;min-width:0!important;
  display:flex!important;align-items:center!important;
  min-height:44px!important;
  color:rgb(17,17,17)!important;text-decoration:none!important;
  font-family:var(--font-body-family),sans-serif!important;
  font-size:16px!important;font-weight:400!important;
  line-height:1.2!important;letter-spacing:normal!important;
  white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;
}
#predictive__search_overlay .cf-search-recents__delete{
  flex:0 0 44px!important;
  width:44px!important;height:44px!important;
  min-width:44px!important;min-height:44px!important;
  padding:10px!important;margin:0!important;
  display:flex!important;align-items:center!important;justify-content:center!important;
  border:0 none!important;background:transparent!important;
  border-radius:50%!important;cursor:pointer!important;
  color:rgba(0,0,0,0.35)!important;
  -webkit-tap-highlight-color:transparent!important;
  box-sizing:border-box!important;
  /* NO transition: feedback instantáneo en :active, no 100ms fade que se pierde
     cuando el click handler borra el elemento */
  transition:none!important;
}
#predictive__search_overlay .cf-search-recents__delete svg{
  width:24px!important;height:24px!important;
  display:block!important;
  color:inherit!important;stroke:currentColor!important;
  stroke-width:1.5!important;fill:none!important;
}
/* :hover fallback + .cf-recents-deleting (clase JS que mantiene feedback visible
   durante el delay de 200ms antes del fade-out del item) */
#predictive__search_overlay .cf-search-recents__delete:hover,
#predictive__search_overlay .cf-search-recents__delete:active,
#predictive__search_overlay .cf-search-recents__delete.cf-recents-deleting{
  background:rgba(0,0,0,0.10)!important;
  color:rgba(0,0,0,0.60)!important;
}
/* Transición suave del item para el fade-out al eliminar */
#predictive__search_overlay .cf-search-recents__item{
  transition:opacity 160ms ease, transform 160ms ease!important;
}

@media(prefers-reduced-motion:reduce){*{transition:none!important;animation:none!important;}}
`;
    document.head.appendChild(st);
  };

  // FETCH INTERCEPTOR
  if (!window.__cfPsFetched) {
    window.__cfPsFetched = true;
    const origFetch = window.fetch;
    window.fetch = function (url, opts) {
      try {
        const u = (url instanceof Request) ? url.url : url;
        if (typeof u === 'string' && u.includes('/search/suggest')
            && (u.includes('resources%5Btype%5D=product') || u.includes('resources[type]=product'))) {
          const qMatch = u.match(/[?&]q=([^&]*)/);
          const q = qMatch ? decodeURIComponent(qMatch[1]).trim() : '';
          if (q.length < MIN_CHARS) return Promise.resolve(new Response('', {
            status: 200,
            headers: { 'Content-Type': 'text/html; charset=utf-8' }
          }));
          let next = u.replace(/resources%5Blimit%5D=\d+/g, 'resources%5Blimit%5D=10')
                      .replace(/resources\[limit\]=\d+/g, 'resources[limit]=10');
          // COVRFLY — Buscar por modelo de celular (variants.title)
          if (!next.includes('variants.title')) {
            next = next.replace(/resources%5Boptions%5D%5Bfields%5D=([^&]*)/, 'resources%5Boptions%5D%5Bfields%5D=$1%2Cvariants.title')
                       .replace(/resources\[options\]\[fields\]=([^&]*)/, 'resources[options][fields]=$1,variants.title');
          }
          url = (url instanceof Request) ? new Request(next, url) : next;
        }
      } catch (_) {}
      return origFetch.call(this, url, opts);
    };
  }

  const countReal = (overlay) => {
    let n = 0;
    overlay.querySelectorAll('.predictive-search__list-item').forEach(li => {
      if (!li.querySelector('.predictive-search__item--term')) n++;
    });
    return n;
  };

  let isApplying = false;

  // Hide sticky/fixed elements when search is open, restore when closed
  const hideStickyElements = () => {
    const candidates = [...document.body.children];
    candidates.forEach(el => {
      if (el.id === 'predictive__search_overlay' || el.contains(document.getElementById('predictive__search_overlay'))) return;
      // COVRFLY Fase 9 — Flash fix: NO ocultar el menú hamburguesa (cfm17-root)
      // durante el handoff menú → lupita. El menú está ENCIMA de la lupita
      // (z-index 2147483000 vs 99999) y debe permanecer visible para cubrir
      // el homepage mientras la lupita hace fade-in por debajo. Si lo ocultamos
      // aquí, el homepage queda visible por ~300ms → FLASH reportado.
      if (el.id === 'cfm17-root') return;
      if (['SCRIPT', 'STYLE', 'LINK', 'META', 'NOSCRIPT'].includes(el.tagName)) return;
      const cs = getComputedStyle(el);
      if ((cs.position === 'fixed' || cs.position === 'sticky') && cs.visibility !== 'hidden') {
        if (el.dataset.cfWasVis) return;
        el.dataset.cfWasVis = '1';
        el.dataset.cfPrevVis = el.style.getPropertyValue('visibility') || '';
        el.style.setProperty('visibility', 'hidden', 'important');
      }
    });
  };

  const restoreStickyElements = () => {
    document.querySelectorAll('[data-cf-was-vis]').forEach(el => {
      const prev = el.dataset.cfPrevVis || '';
      el.style.removeProperty('visibility');
      if (prev) el.style.setProperty('visibility', prev);
      delete el.dataset.cfPrevVis;
      delete el.dataset.cfWasVis;
    });
  };

  // === COVRFLY Fase 9 — Scroll Lock v3 ===
  // Safety-net CSS var: one-shot window.innerHeight (estable, sin jitter del
  // visualViewport). Se aplica al abrir y en resize/orientationchange.
  const syncLupitaHeight = () => {
    const h = window.innerHeight;
    if (h > 0) document.documentElement.style.setProperty('--cf-lupita-h', h + 'px');
  };
  const clearLupitaHeight = () => {
    document.documentElement.style.removeProperty('--cf-lupita-h');
  };

  // Body lock con inheritance check: si el menú ya tiene body locked
  // (position:fixed + top:-scrollY), NO re-aplicamos para evitar un jump
  // visual (-3000px → 0). Marcamos como inherited para que el release
  // no toque el estilo (el menú lo restaurará cuando se cierre).
  const applyBodyLock = () => {
    if (window.__cfPsBodyLock) return;
    const menuOwnsLock = !!(window.__cfm17_state && window.__cfm17_state.bodyLock);
    const bodyAlreadyFixed = document.body.style.position === 'fixed';
    if (menuOwnsLock || bodyAlreadyFixed) {
      window.__cfPsBodyLock = { inherited: true };
      document.documentElement.classList.add('cf-lupita-locked');
      syncLupitaHeight();
      return;
    }
    const scrollY = window.scrollY || window.pageYOffset || 0;
    window.__cfPsBodyLock = {
      scrollY,
      overflow: document.body.style.overflow,
      position: document.body.style.position,
      top: document.body.style.top,
      width: document.body.style.width,
      htmlOverflow: document.documentElement.style.overflow,
      osb: document.documentElement.style.overscrollBehavior,
      inherited: false
    };
    document.documentElement.style.overscrollBehavior = 'none';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
    document.documentElement.classList.add('cf-lupita-locked');
    syncLupitaHeight();
  };

  const releaseBodyLock = () => {
    const lock = window.__cfPsBodyLock;
    document.documentElement.classList.remove('cf-lupita-locked');
    clearLupitaHeight();
    if (!lock) return;
    window.__cfPsBodyLock = null;
    if (lock.inherited) return; // menu owns the lock, no tocar
    document.body.style.overflow = lock.overflow || '';
    document.body.style.position = lock.position || '';
    document.body.style.top = lock.top || '';
    document.body.style.width = lock.width || '';
    document.documentElement.style.overflow = lock.htmlOverflow || '';
    document.documentElement.style.overscrollBehavior = lock.osb || '';
    const y = lock.scrollY || 0;
    if (y) window.scrollTo(0, y);
  };

  // === COVRFLY — Swipe-to-close on lupita (homologar con menú hamburguesa) ===
  // Misma lógica que el menú: direction lock 8px, real-time tracking,
  // threshold 30% del ancho OR velocity -0.5 px/ms, scrim proporcional,
  // rubber-band back si no llega. Solo left-swipe (dx < 0). Ignora multi-touch.
  // Listeners se bindean en fixAll (al abrir) y se desbindean en cleanupOnClose.
  const SWIPE_DIR_LOCK_PX = 8;
  const SWIPE_CLOSE_DIST_RATIO = 0.30;
  const SWIPE_CLOSE_VELOCITY = -0.5; // px/ms, leftward
  let __cfSwipeState = null;
  let __cfSwipeHandlers = null;
  let __cfSwipeDragging = false;
  const bindSwipeToClose = () => {
    const overlay = document.getElementById('predictive__search_overlay');
    if (!overlay) return;
    const panel = overlay.querySelector('.search__content_inner');
    if (!panel) return;
    if (__cfSwipeHandlers && __cfSwipeHandlers.panel === panel) return;
    if (__cfSwipeHandlers) unbindSwipeToClose();
    const searchModalEl = overlay.closest('search-modal');

    // setProperty con 'important' porque el CSS inyectado tiene !important
    // en transform/opacity/transition del panel y overlay.
    const setS = (el, k, v) => el.style.setProperty(k, v, 'important');
    const clrS = (el, k) => el.style.removeProperty(k);

    const resetPanel = () => {
      setS(panel, 'transition', 'transform .28s cubic-bezier(.2,.8,.2,1), opacity .28s ease');
      setS(overlay, 'transition', 'opacity .28s ease');
      // FIX iOS Safari quirk: sin forced reflow, el browser batcha
      // transition+transform en el mismo task y no dispara la transición.
      void panel.offsetHeight;
      setS(panel, 'transform', 'translateX(0)');
      setS(panel, 'opacity', '1');
      setS(overlay, 'opacity', '1');
      setTimeout(() => {
        clrS(panel, 'transform');
        clrS(panel, 'opacity');
        clrS(panel, 'transition');
        clrS(overlay, 'opacity');
        clrS(overlay, 'transition');
        __cfSwipeDragging = false;
      }, 300);
    };

    const closeAnim = () => {
      setS(panel, 'transition', 'transform .22s cubic-bezier(.4,0,1,1), opacity .22s ease');
      setS(overlay, 'transition', 'opacity .22s ease');
      // FIX iOS Safari: forced reflow (ver resetPanel)
      void panel.offsetHeight;
      setS(panel, 'transform', 'translateX(-100%)');
      setS(panel, 'opacity', '0');
      setS(overlay, 'opacity', '0');
      setTimeout(() => {
        __cfSwipeDragging = false;
        // Disparar el close del modal. El observer verá la clase removida,
        // fixAll correrá con !isOpen → cleanupOnClose → releaseBodyLock + unbind.
        if (searchModalEl) {
          if (typeof searchModalEl.close === 'function') searchModalEl.close();
          else {
            searchModalEl.classList.remove('active');
            document.body.classList.remove('body-overflow-hidden');
          }
          searchModalEl.classList.remove('from-menu');
        }
        // Clear inline; el estado CSS post-close matches (translateX(-100%), opacity 0)
        clrS(panel, 'transform');
        clrS(panel, 'opacity');
        clrS(panel, 'transition');
        clrS(overlay, 'opacity');
        clrS(overlay, 'transition');
      }, 220);
    };

    const onStart = (e) => {
      if (!e.touches || e.touches.length !== 1) { __cfSwipeState = null; return; }
      const t = e.touches[0];
      __cfSwipeState = {
        x0: t.clientX, y0: t.clientY,
        dir: null,
        lastX: t.clientX, lastT: performance.now(), vX: 0,
        panelW: panel.offsetWidth,
      };
    };

    const onMove = (e) => {
      if (!__cfSwipeState) return;
      if (!e.touches || e.touches.length !== 1) { __cfSwipeState = null; return; }
      const t = e.touches[0];
      const dx = t.clientX - __cfSwipeState.x0;
      const dy = t.clientY - __cfSwipeState.y0;
      const absDx = Math.abs(dx), absDy = Math.abs(dy);

      // Direction lock (una sola vez)
      if (!__cfSwipeState.dir) {
        if (absDx < SWIPE_DIR_LOCK_PX && absDy < SWIPE_DIR_LOCK_PX) return;
        if (absDy >= absDx || dx >= 0) {
          __cfSwipeState.dir = 'v';
          return;
        }
        __cfSwipeState.dir = 'h';
        __cfSwipeDragging = true; // bloquea fixAll durante el drag
        setS(panel, 'transition', 'none');
        setS(overlay, 'transition', 'none');
      }

      if (__cfSwipeState.dir !== 'h') return;

      const now = performance.now();
      const dtv = now - __cfSwipeState.lastT;
      if (dtv > 0) {
        __cfSwipeState.vX = (t.clientX - __cfSwipeState.lastX) / dtv;
        __cfSwipeState.lastX = t.clientX;
        __cfSwipeState.lastT = now;
      }

      const clampedDx = Math.max(-__cfSwipeState.panelW, Math.min(0, dx));
      const progress = Math.abs(clampedDx) / __cfSwipeState.panelW;

      setS(panel, 'transform', 'translateX(' + clampedDx + 'px)');
      setS(panel, 'opacity', String(1 - progress * 0.4));
      setS(overlay, 'opacity', String(1 - progress));

      if (e.cancelable) e.preventDefault();
    };

    const onEnd = (e) => {
      if (!__cfSwipeState) return;
      if (__cfSwipeState.dir !== 'h') { __cfSwipeState = null; return; }
      const t = (e.changedTouches && e.changedTouches[0]) || null;
      const dx = t ? (t.clientX - __cfSwipeState.x0) : 0;
      const clampedDx = Math.max(-__cfSwipeState.panelW, Math.min(0, dx));
      const progress = Math.abs(clampedDx) / __cfSwipeState.panelW;
      const shouldClose = progress >= SWIPE_CLOSE_DIST_RATIO || __cfSwipeState.vX <= SWIPE_CLOSE_VELOCITY;
      __cfSwipeState = null;
      if (shouldClose) {
        closeAnim();
      } else {
        // FIX BUG 1: search-modal.js tiene un legacy touchend handler en
        // capture phase sobre <search-modal> que cierra el modal si
        // dx < -80. Corre ANTES de éste (capture vs bubble), así que en
        // swipes cortos entre 80px y el threshold de 30% del ancho, el
        // legacy handler ya removió .active + body-overflow-hidden cuando
        // llegamos acá. Re-agregamos las clases sincrónicamente antes del
        // rubber-band para que el estado abierto quede consistente y
        // cleanupOnClose no se dispare al terminar la transición.
        if (searchModalEl && !searchModalEl.classList.contains('active')) {
          searchModalEl.classList.add('active');
        }
        if (!document.body.classList.contains('body-overflow-hidden')) {
          document.body.classList.add('body-overflow-hidden');
        }
        resetPanel();
      }
    };

    const onCancel = () => {
      if (!__cfSwipeState) return;
      if (__cfSwipeState.dir === 'h') resetPanel();
      __cfSwipeState = null;
    };

    panel.addEventListener('touchstart', onStart, { passive: true });
    panel.addEventListener('touchmove', onMove, { passive: false });
    panel.addEventListener('touchend', onEnd, { passive: true });
    panel.addEventListener('touchcancel', onCancel, { passive: true });

    __cfSwipeHandlers = { panel, onStart, onMove, onEnd, onCancel };
  };

  function unbindSwipeToClose() {
    if (!__cfSwipeHandlers) return;
    const h = __cfSwipeHandlers;
    h.panel.removeEventListener('touchstart', h.onStart);
    h.panel.removeEventListener('touchmove', h.onMove);
    h.panel.removeEventListener('touchend', h.onEnd);
    h.panel.removeEventListener('touchcancel', h.onCancel);
    __cfSwipeHandlers = null;
    __cfSwipeState = null;
    __cfSwipeDragging = false;
  }

  // Cleanup when search panel CLOSES
  const cleanupOnClose = () => {
    unbindSwipeToClose();
    releaseBodyLock();
    delete document.body.dataset.cfStickyHid;
    restoreStickyElements();
  };

  // === COVRFLY Fase 9 — wrap cfMenuRevert para ownership transfer ===
  // Si la lupita está abierta cuando el menú intenta hacer revert (cerrar),
  // transferimos el body lock del menú al __cfPsBodyLock y nulleamos el
  // __cfm17_state.bodyLock para que el orig NO restaure body (scroll jump).
  const wrapCfMenuRevert = () => {
    if (typeof window.cfMenuRevert !== 'function') return false;
    if (window.cfMenuRevert.__cfPsWrapped) return true;
    const orig = window.cfMenuRevert;
    const wrapped = function () {
      try {
        const modal = document.querySelector('search-modal');
        const lupitaOpen = modal && modal.classList.contains('active');
        const menuLock = window.__cfm17_state && window.__cfm17_state.bodyLock;
        if (lupitaOpen && menuLock) {
          window.__cfPsBodyLock = {
            scrollY: menuLock.scrollY,
            overflow: menuLock.overflow,
            position: menuLock.position,
            top: menuLock.top,
            width: menuLock.width,
            htmlOverflow: document.documentElement.style.overflow,
            osb: menuLock.osb,
            inherited: false
          };
          window.__cfm17_state.bodyLock = null;
          document.documentElement.classList.add('cf-lupita-locked');
          syncLupitaHeight();
        }
      } catch (_) {}
      return orig.apply(this, arguments);
    };
    wrapped.__cfPsWrapped = true;
    window.cfMenuRevert = wrapped;
    return true;
  };
  // Retries: el menú puede cargar después de cf-predictive.
  if (!wrapCfMenuRevert()) {
    document.addEventListener('DOMContentLoaded', wrapCfMenuRevert, { once: true });
    setTimeout(wrapCfMenuRevert, 50);
    setTimeout(wrapCfMenuRevert, 250);
    setTimeout(wrapCfMenuRevert, 1000);
  }

  const fixAll = () => {
    if (isApplying) return;
    // Durante un swipe-drag horizontal, NO tocar el panel/overlay: el drag
    // usa inline transform/opacity con !important y fixAll removería todo.
    if (__cfSwipeDragging) return;
    const overlay = $('#predictive__search_overlay');
    const searchModalEl = overlay ? overlay.closest('search-modal') : null;

    // Detección robusta: overlay.active OR search-modal.active
    // (cuando se abre desde el menú, el active puede estar en el contenedor).
    const isOpen = !!overlay && (
      overlay.classList.contains('active') ||
      (searchModalEl && searchModalEl.classList.contains('active'))
    );
    if (!isOpen) {
      cleanupOnClose();
      return;
    }
    isApplying = true;
    try {

    const inner = $('.search__content_inner', overlay);
    const webComp = $('predictive-search.search-modal__form', overlay);
    const form = $('form.search.search-modal__form', overlay);
    const resultsPanel = $('.predictive-search.predictive-search--header', overlay);
    const resultsRoot = $('#predictive-search-results', overlay);
    const input = $('#Search-In-Modal', overlay);
    const q = (input && input.value ? input.value.trim() : '');

    overlay.removeAttribute('style');
    if (inner) inner.removeAttribute('style');
    if (webComp) webComp.removeAttribute('style');
    if (form) form.removeAttribute('style');
    if (resultsPanel) resultsPanel.removeAttribute('style');

    setImp(overlay, {position:'fixed',inset:'0',width:'100vw',height:'100dvh',display:'flex','justify-content':'flex-start','align-items':'stretch','z-index':'99999'});
    setImp(inner, {display:'flex','flex-direction':'column','justify-content':'flex-start','align-items':'stretch',height:'100dvh',overflow:'hidden',padding:'0','border-radius':'0'});
    setImp(webComp, {display:'flex','flex-direction':'column',flex:'1 1 0px','min-height':'0',width:'100%',height:'auto'});
    setImp(form, {display:'flex','flex-direction':'column',flex:'1 1 0px','min-height':'0',width:'100%',margin:'0',padding:'0'});
    setImp(resultsPanel, {position:'relative',top:'auto',left:'auto',right:'auto',bottom:'auto',flex:'1 1 0px','min-height':'0','overflow-y':'auto','overflow-x':'hidden',display:'flex','flex-direction':'column'});

    const closeBtn = $('#search__close_btn', overlay);

    if (!overlay.getAttribute('role')) {
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Búsqueda de productos');
    }
    if (input && !input.getAttribute('aria-label')) input.setAttribute('aria-label', 'Buscar productos');
    if (closeBtn && !closeBtn.getAttribute('aria-label')) closeBtn.setAttribute('aria-label', 'Cerrar búsqueda');
    if (input && input.placeholder !== PLACEHOLDER) input.placeholder = PLACEHOLDER;
    const heading = $('.predictive-search__heading', overlay);
    if (heading && heading.textContent.trim().toUpperCase() !== HEADING_TEXT) heading.textContent = HEADING_TEXT;

    $$('.predictive-search__item--term', overlay).forEach(el => {
      setImp(el, {display:'none'});
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('tabindex', '-1');
    });

    $$('.predictive-search__image', overlay).forEach(img => {
      const src = img.getAttribute('src') || '';
      const next = src.replace(/_(?:150|200|250|300|360|400)x(?=\.)/g, '_500x');
      if (next !== src) img.setAttribute('src', next);
      if (img.getAttribute('width')) img.removeAttribute('width');
      if (img.getAttribute('height')) img.removeAttribute('height');
    });

    $$('.predictive-search__item-heading', overlay).forEach(h => {
      setImp(h, {'white-space':'nowrap',overflow:'hidden','text-overflow':'ellipsis',display:'block','max-width':'100%',width:'100%'});
    });
    $$('.predictive-search__item-content', overlay).forEach(c => {
      setImp(c, {overflow:'hidden','min-width':'0','max-width':'100%'});
    });

    const realProducts = countReal(overlay);

    let noResEl = $('#' + NORESULTS_ID, resultsPanel);
    if (!noResEl && resultsPanel) {
      noResEl = document.createElement('div');
      noResEl.id = NORESULTS_ID;
      noResEl.innerHTML = `<span>${NORESULTS_MSG}</span>`;
      resultsPanel.appendChild(noResEl);
    }

    let viewAllWrap = $('#' + VIEWALL_ID, overlay);
    if (!viewAllWrap && form) {
      viewAllWrap = document.createElement('div');
      viewAllWrap.id = VIEWALL_ID;
      const link = document.createElement('a');
      link.id = VIEWALL_LINK;
      link.textContent = 'Ver todos los resultados →';
      viewAllWrap.appendChild(link);
      form.appendChild(viewAllWrap);
    }
    if (viewAllWrap && form && viewAllWrap.parentElement !== form) form.appendChild(viewAllWrap);

    if (q.length < MIN_CHARS) {
      if (resultsRoot) setImp(resultsRoot, {display:'none'});
      if (noResEl) setImp(noResEl, {display:'none'});
      if (viewAllWrap) setImp(viewAllWrap, {display:'none'});
    } else if (realProducts === 0) {
      if (resultsRoot) setImp(resultsRoot, {display:'none'});
      if (noResEl) setImp(noResEl, {display:'flex'});
      if (viewAllWrap) setImp(viewAllWrap, {display:'none'});
    } else {
      if (resultsRoot) setImp(resultsRoot, {display:'block'});
      if (noResEl) setImp(noResEl, {display:'none'});
      if (viewAllWrap) {
        setImp(viewAllWrap, {display:'block'});
        const link = $('#' + VIEWALL_LINK, viewAllWrap);
        if (link) link.href = `/search?q=${encodeURIComponent(q)}&type=product`;
      }
      if (resultsPanel) resultsPanel.classList.remove('cf-loading');
    }

    // Scroll lock v3 — 4-layer defense (reemplaza weak overflow:hidden)
    applyBodyLock();

    // Swipe-to-close: bind listeners (idempotente — return si ya está bound
    // al mismo panel). Unbind automático en cleanupOnClose.
    bindSwipeToClose();

    // Hide sticky elements (like "Agregar Al Carrito") behind overlay — once per open
    if (!document.body.dataset.cfStickyHid) {
      document.body.dataset.cfStickyHid = '1';
      hideStickyElements();
    }

    } catch (e) {
      console.error('COVRFLY v10.1 fixAll error:', e);
    } finally {
      queueMicrotask(() => { isApplying = false; });
    }
  };

  // SCHEDULING
  let scheduled = false, lastRun = 0;
  const scheduleApply = () => {
    if (scheduled) return;
    const wait = Math.max(0, 80 - (performance.now() - lastRun));
    scheduled = true;
    const run = () => { scheduled = false; lastRun = performance.now(); ensureStyle(); fixAll(); };
    wait === 0 ? requestAnimationFrame(run) : setTimeout(run, wait);
  };

  const bindInput = () => {
    const overlay = $('#predictive__search_overlay');
    const input = overlay && $('#Search-In-Modal', overlay);
    if (!input || input.dataset.cfBound) return;
    input.dataset.cfBound = '1';
    input.addEventListener('input', () => {
      const rp = $('.predictive-search.predictive-search--header', overlay);
      if (rp && input.value.trim().length >= MIN_CHARS) rp.classList.add('cf-loading');
      scheduleApply();
      setTimeout(scheduleApply, 200);
      setTimeout(scheduleApply, 500);
    }, {passive:true});
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { const btn = $('#search__close_btn', overlay); if (btn) btn.click(); }
    });
  };

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const overlay = $('#predictive__search_overlay');
    if (!overlay || !overlay.classList.contains('active')) return;
    const focusable = overlay.querySelectorAll('input,button,a[href],[tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  const observer = new MutationObserver(() => {
    if (!isApplying) { scheduleApply(); bindInput(); }
  });
  observer.observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['class','style']});

  // === COVRFLY Fase 9 — Defense listeners (bound once, globales) ===
  if (!window.__cfPsDefenseBound) {
    window.__cfPsDefenseBound = true;
    // Layer 3: touchmove preventDefault fuera del panel scrollable
    document.addEventListener('touchmove', (e) => {
      if (!window.__cfPsBodyLock) return;
      const t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest('.search__content_inner')) { e.preventDefault(); return; }
      if (!t.closest('.predictive-search.predictive-search--header, .cf-search-populars')) {
        e.preventDefault();
      }
    }, { passive: false });
    // Layer 4: phantom scroll reset (iOS keyboard pan bypass)
    window.addEventListener('scroll', () => {
      if (!window.__cfPsBodyLock || window.__cfPsBodyLock.inherited) return;
      if (window.scrollY !== 0) window.scrollTo(0, 0);
    }, { passive: true });
    // Height re-sync en resize/orientationchange
    window.addEventListener('resize', () => {
      if (window.__cfPsBodyLock) syncLupitaHeight();
    });
    window.addEventListener('orientationchange', () => {
      if (window.__cfPsBodyLock) setTimeout(syncLupitaHeight, 100);
    });
  }

  ensureStyle();
  scheduleApply();
  bindInput();

  // === COVRFLY — Recents delete: visible feedback (200ms) + fade-out (160ms) ===
  // El click handler original vive en search-modal.js (document capture) y elimina
  // el item instantáneamente, por lo que el :active feedback dura 0ms y es invisible.
  // Fix: en móvil, interceptamos touchend con preventDefault() → cancela el click
  // sintético → search-modal.js nunca corre → nosotros controlamos todo el flujo:
  //
  //   1. touchstart (noop): activa :active en iOS Safari (quirk de dynamic DOM)
  //   2. touchend.preventDefault(): cancela click → evita search-modal.js
  //   3. Añadimos clase .cf-recents-deleting → mantiene gris visible durante 200ms
  //   4. Después de 200ms: opacity→0 + translateX(-10px) (fade-out 160ms)
  //   5. Después de 160ms más: update localStorage + item.remove()
  //
  // Desktop (mouse): no se interviene. El usuario ya tiene :hover instantáneo,
  // el click rápido de search-modal.js es apropiado para mouse.
  (function setupRecentsDeleteFlow() {
    const list = document.querySelector('[data-search-recents-list]');
    if (!list) {
      requestAnimationFrame(setupRecentsDeleteFlow);
      return;
    }

    const RECENT_KEY = 'covrfly_recent_searches';
    const FEEDBACK_MS = 200;
    const FADE_MS = 160;

    const getRecents = function () {
      try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); }
      catch (e) { return []; }
    };
    const setRecents = function (items) {
      localStorage.setItem(RECENT_KEY, JSON.stringify(items.slice(0, 5)));
    };

    const runDeleteFlow = function (btn, term) {
      const item = btn.closest('.cf-search-recents__item');
      if (!item || item.__cfDeleting) return;
      item.__cfDeleting = true;

      // Mantener el fondo gris visible durante FEEDBACK_MS
      btn.classList.add('cf-recents-deleting');

      setTimeout(function () {
        // Fade out el item completo
        item.style.opacity = '0';
        item.style.transform = 'translateX(-10px)';

        setTimeout(function () {
          // Persistir cambio + remover DOM
          const next = getRecents().filter(function (x) { return x !== term; });
          setRecents(next);
          item.remove();
          // Ocultar wrap si quedó vacío
          if (next.length === 0) {
            const wrap = document.querySelector('[data-search-recents]');
            if (wrap) wrap.hidden = true;
          }
        }, FADE_MS);
      }, FEEDBACK_MS);
    };

    const onTouchStart = function () { /* noop: activa :active en iOS */ };

    const onTouchEnd = function (e) {
      const btn = e.currentTarget;
      const term = btn.getAttribute('data-recent-delete');
      if (!term) return;
      // Cancela el click sintético que iOS/Android dispararía después →
      // evita que search-modal.js ejecute su delete instantáneo
      e.preventDefault();
      runDeleteFlow(btn, term);
    };

    const attachToButtons = function () {
      list.querySelectorAll('.cf-search-recents__delete').forEach(function (btn) {
        if (btn.__cfDelHooked) return;
        btn.__cfDelHooked = true;
        btn.addEventListener('touchstart', onTouchStart, { passive: true });
        btn.addEventListener('touchend', onTouchEnd, { passive: false });
      });
    };

    attachToButtons();
    new MutationObserver(attachToButtons).observe(list, { childList: true, subtree: true });
  })();

  console.log('✅ COVRFLY v10.1: production clean (try/finally, microtask, sticky fix, no elastic) + scroll-lock v3');
})();
